import { FC } from "react";
import { LoadingSpinner } from "@app/shared/index";
import * as React from "react";

interface MetricsTilesProps {
  data?: MetricsTileData[];
  loading: boolean;
}

export interface MetricsTileData {
  label: string;
  value: string;
  testId: string;
}

const MetricsTiles: FC<MetricsTilesProps> = ({ data, loading }) => {
  return (
    <div className={"metrics-tile-container"}>
      {loading || !data ?
        <LoadingSpinner/> :
        data.length > 0 ?
          data.map((tile, index) => (
            <div key={index} className={"metrics-tile-container__tile"} id={tile.testId}>
              <p className={"metrics-tile-container__label"}>{tile.label}</p>
              <p className={"metrics-tile-container__value"}>{tile.value}</p>
            </div>
          )) :
          <h3 className="text-muted no-content-text">There are no records for this selection.</h3>
      }
    </div>
  );
}

export default MetricsTiles;